import React from "react"
import { Box } from "@mui/material";
import AuthCodeVerification from "./Components/AuthCodeVerification";
import Loader from 'components/Loader/Loader.jsx'

export default function Template({ ...sharedProps }) {
	const {
		handleClose,
		handleSave,
		requestSmsCode,
		isLoading,
		resetForm,
		consumer,
		alert,
		loading,
		handleSent,
		sendSMSActivationCode,
		props,
		isEcommerce,
		hideOnEcommerce,
		themeColor,
		loadingInitial,
		emailToken,
	} = sharedProps

	if (loadingInitial) {
		return <Loader />;
	}

	return (
		<Box key={resetForm}>
			{loading && <Loader />}
			{alert}
			<AuthCodeVerification
				key={resetForm}
				themeColor={themeColor}
				emailToken={emailToken}
				isEcommerce={isEcommerce}
				hideOnEcommerce={hideOnEcommerce}
				handleClose={handleClose.bind(this)}
				requestSmsCode={requestSmsCode.bind(this)}
				history={props.history}
				onSubmit={handleSave.bind(this)}
				props={props}
				handleSent={handleSent}
				isLoading={isLoading}
				consumer={consumer}
				sendSMSActivationCode={sendSMSActivationCode}
			/>
		</Box>
	);
}
